import { render, staticRenderFns } from "./vehicle-administration.vue?vue&type=template&id=6055f9c0&scoped=true"
import script from "./vehicle-administration.vue?vue&type=script&lang=js"
export * from "./vehicle-administration.vue?vue&type=script&lang=js"
import style0 from "./vehicle-administration.vue?vue&type=style&index=0&id=6055f9c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055f9c0",
  null
  
)

export default component.exports